module.exports = __webpack_public_path__ + "img/linkedin.4b583c6b.png";